import React from "react"
import { cn } from "~/utils/tailwind"

export const ListItem = ({ children, className }: { children: React.ReactNode; className?: string }) => {
  return <div className={cn("border rounded-lg w-full p-4", className)}>{children}</div>
}

export const List = ({ children }: { children: React.ReactNode }) => {
  return <div className="w-full">{children}</div>
}

export const ListContent = ({ children }: { children: React.ReactNode }) => {
  return <div className="w-full flex flex-col gap-2">{children}</div>
}
